import React, { type FC } from 'react';
import Checkbox, { type CheckboxProps } from "@mui/material/Checkbox";
import InputAdornment from "@mui/material/InputAdornment";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
  
export const ShowPasswordCheckbox: FC<CheckboxProps> = (props) => {
    return (
        <InputAdornment position="end">
            <Checkbox
                color="default"
                className="show_password_checkbox"
                icon={<VisibilityIcon fontSize="small" />}
                checkedIcon={<VisibilityOffIcon fontSize="small" />}
                {...props}
            />
        </InputAdornment>
    )
}